export class Modals {
    constructor() {
        this.modals = [...document.querySelectorAll('.modal')];
        this.handleBodyClick = this.handleBodyClick.bind(this);

        // Check for terms modal - only rendered if cookie is not present
        const modalTerms = this.showModal('terms');

        if (modalTerms) {
            modalTerms.querySelector('.btn').addEventListener('click', (event) => {
                event.preventDefault();
                this.storeTermsCookie();
                modalTerms.remove();
                document.body.classList.remove('show-terms');
            });
        }

        const newsletterToggle = document.querySelector('[data-target="newsletter"]');

        if (newsletterToggle) {
            newsletterToggle.addEventListener('click', () => {
                const form = document.querySelector('.form-newsletter_wrapper');
                form.classList.add('show-form');
                newsletterToggle.classList.add('hidden');

                setTimeout(() => {
                    form.querySelector('input[type="email"]').focus();
                }, 50);
            });
        }

        // Callback Request
        // const requestCallbackToggle = document.querySelector('.menu-request-callback');
        // requestCallbackToggle.addEventListener('click', event => {
        //     event.preventDefault();
        //     this.showModal('callback', true);
        // })
    }

    showModal(key, show = true) {
        const modal = this.modals.find(m => m.classList.contains(`modal-${key}`));

        if (modal) {
            modal.classList[show ? 'add' : 'remove' ]('show-modal');

            if (show) {
                const closeBtn = modal.querySelector('.close');

                if (closeBtn) {
                    document.body[`${show ? 'add' : 'remove'}EventListener`]('click', this.handleBodyClick);

                    closeBtn.addEventListener('click', (event) => {
                        event.preventDefault();
                        modal.classList.remove('show-modal');
                    }, true);
                }
            }
        }

        return modal;
    }

    handleBodyClick(event) {
        const targetModal = event.target.dataset.modal;
        if (targetModal) {
            this.showModal(targetModal, false);
        }
    }

    storeTermsCookie() {
        const date = new Date();
        const days = 3600;
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = `calculus_terms_agree=yes; expires=${date.toGMTString()}; path=/`;
    }
}